module.exports = __webpack_public_path__ + "fonts/effect-chronal-anchor-e1443e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-chronal-anchor.svg
// module id = 720
// module chunks = 0